import { Loader as ChameleonLoader } from '@mediahuis/chameleon-react';
import React, { FC } from 'react';

// Wrapper component for chameleon loader to unify styling throughout the application.
const Loader: FC<typeof ChameleonLoader.defaultProps> = (props) => {
  return <ChameleonLoader {...props} size="2xl" />;
};
export default Loader;
